import { render, staticRenderFns } from "./CreateOrUpdateForm.vue?vue&type=template&id=3f239d3b"
import script from "./CreateOrUpdateForm.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports